import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { getdataforDrilldown, getfilterdatadrill, exportexcelreport, exportpdfreport, exportcsvreport, defaultexport } from "../../actions/reportmanagement";
import { Container, Menu, MenuItem, CircularProgress } from "@mui/material";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import GetAppIcon from '@mui/icons-material/GetApp';
import _ from "lodash";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import ClearAllIcon from '@mui/icons-material/ClearAll';
import { MdPictureAsPdf } from "react-icons/md";
import { FaFileExcel } from "react-icons/fa6";
import { FaFileCsv } from "react-icons/fa";
import { decryptData } from '../utils/EncriptionStore';
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import pako from 'pako';
import CustomFilterDrilldown from './CustomFilterDrilldown';
import { toast } from 'react-toastify';
import {
  Box,
  Button,
  IconButton,
  Popover,
  TextField,
  List,
  ListItem,
  ListItemButton,
  Tooltip,
  Typography,
} from "@mui/material";
import CalendarMonthSharpIcon from "@mui/icons-material/CalendarMonthSharp";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function DrillDown() {

  const [data, setData] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [titlereport, settitleOfReport] = React.useState('');
  const [sorting, setSorting] = useState([]);
  const [loading, setLoading] = useState(true); // New loading state
  const [rowCount, setRowCount] = useState();
  const [openCustomFilter, setOpenCustomFilter] = useState(false)
  const [showcolumnFilter, setShowcolumnFilter] = useState(false)
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [dateRange, setDateRange] = useState([null, null]); // [start, end]
  const [rangeAnchorEl, setRangeAnchorEl] = useState(null);
  const rangeOpen = Boolean(rangeAnchorEl);
  const dropdownOptions = [
    { label: "Last 7 Day(s)", value: 7 },
    { label: "Last 15 Day(s)", value: 15 },
    { label: "Last 1 Month(s)", value: 30 },
    { label: "Custom", value: "custom" },
  ];


  const [conditions, setConditions] = useState([
    { selectedData: "", selectedCondition: "", selectedValue: [], filteredValues: [], startDate: "", endDate: "", type: "" }
  ]);
  const DateTimeType = [
    "TIMESTAMP", "DATE", "DATETIME", "NEWDATE", "TIMESTAMPTZ", "TIMETZ"
  ]
  const IntigetType = [
    "INT", "INTEGER", "FLOAT", "DOUBLE", "INT2VECTOR", "NUMRANGE", "INT4RANGE"
  ]

  const handleRangeClick = (event) => {
    setRangeAnchorEl(event.currentTarget);
  };

  const handleCancel = async () => {
    try {
      const searchParams = new URLSearchParams(window.location.search);
      const reportTitle = searchParams.get("report_title");
      const categoryValue = searchParams.get("category_value") || "";
      const selectedSeriesName = searchParams.get("selected_series_name") || "";
      settitleOfReport(reportTitle);
      setDateRange([null, null])
      setLoading(true);
      await dispatch(
        getdataforDrilldown({
          customer_id: user?.customer_id,
          master_report: reportTitle,
          filter_value: categoryValue,
          selectedSeriesName: selectedSeriesName,
          page_no: pagination.pageIndex + 1,
          page_size: pagination.pageSize,
          database_type: user.database_type,
        })
      );
    } catch (error) {
      console.error("Failed to fetch column drilldown data:", error);
      toast.error("Failed to fetch data. Please try again.");
    } finally {
      setLoading(false);
      setRangeAnchorEl(null);
    }
  };

  const formatDateLocal = (date) => {
    const offset = date?.getTimezoneOffset();
    const localDate = new Date(date?.getTime() - offset * 60 * 1000);
    return localDate?.toISOString().slice(0, 10);
  };

  const handleApply = async () => {
    try {
      const searchParams = new URLSearchParams(window.location.search);
      const reportTitle = searchParams.get("report_title");
      const categoryValue = searchParams.get("category_value") || "";
      const selectedSeriesName = searchParams.get("selected_series_name") || "";
      settitleOfReport(reportTitle);
      if (dateRange[0] && dateRange[1]) {
        //             const start_date = dateRange[0].toISOString().slice(0, 10);
        //             const end_date = dateRange[1].toISOString().slice(0, 10);
        const start_date = formatDateLocal(dateRange[0]);
        const end_date = formatDateLocal(dateRange[1]);
        setLoading(true);
        await dispatch(
          getdataforDrilldown({
            customer_id: user?.customer_id,
            master_report: reportTitle,
            filter_value: categoryValue,
            selectedSeriesName: selectedSeriesName,
            page_no: pagination.pageIndex + 1,
            page_size: pagination.pageSize,
            start_date,
            end_date,
            database_type: user.database_type,
          })
        );
      }
    } catch (error) {
      console.error("Failed to fetch column drilldown data:", error);
      toast.error("Failed to fetch data. Please try again.");
    } finally {
      setLoading(false);
      setRangeAnchorEl(null);
    }
  };

  const handleQuickSelect = (value) => {
    if (value === "custom") {
      setDateRange([null, null]);
      return;
    }
    const end = new Date();
    const start = new Date();
    start.setDate(end.getDate() - (value - 1));
    setDateRange([start, end]);
  };


  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const dispatch = useDispatch();
  const user = (() => {
    const encryptedData = localStorage.getItem("profile");
    return encryptedData ? decryptData(encryptedData) : null;
  })();

  const previewReportTableRowDiv = document.querySelector(".MuiTableRow-head")

  if (previewReportTableRowDiv) {
    previewReportTableRowDiv.classList.add("Drilldownresponsive-header");
    previewReportTableRowDiv.addEventListener("mouseenter", () => {
      previewReportTableRowDiv.style.backgroundColor = "#4d5256";
      previewReportTableRowDiv.style.color = "#fff";
    });
  }

  const apiData = useSelector((state) => state);

  useEffect(() => {
    dispatch(defaultexport())
    const fetchData = async () => {
      const searchParams = new URLSearchParams(window.location.search);
      const reportTitle = searchParams.get("report_title");
      settitleOfReport(reportTitle);
      const categoryValue = searchParams.get("category_value") || "";
      const selectedSeriesName = searchParams.get("selected_series_name") || "";
      try {
        setLoading(true);
        if (reportTitle && categoryValue) {
          await dispatch(
            getdataforDrilldown({
              customer_id: user?.customer_id,
              master_report: reportTitle,
              filter_value: categoryValue,
              selectedSeriesName: selectedSeriesName,
              page_no: pagination.pageIndex + 1,
              page_size: pagination.pageSize,
              database_type: user.database_type,
            })
          );
        }
        else {
          await dispatch(
            getdataforDrilldown({
              customer_id: user?.customer_id,
              master_report: reportTitle,
              selectedSeriesName: selectedSeriesName,
              filter_value: "",
              page_no: pagination.pageIndex + 1,
              page_size: pagination.pageSize,
              database_type: user.database_type,
            })
          );
        }

      } catch (error) {
        console.error("Error generating report ID:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  const searchParams = new URLSearchParams(window.location.search);
  const categoryValue = searchParams.get("category_value") || "";
  const selectedSeriesName = searchParams.get("selected_series_name") || "";
  const enableRangeFilter = searchParams.get("enable_range_filter") || "";

  console.log(enableRangeFilter, "enableRangeFilter")

  const handlePaginationChange = async (updaterOrState) => {
    const searchParams = new URLSearchParams(window.location.search);
    const newState = typeof updaterOrState === "function" ? updaterOrState(pagination) : updaterOrState;
    const reportTitle = searchParams.get("report_title");
    settitleOfReport(reportTitle);
    const categoryValue = searchParams.get("category_value") || "";
    const selectedSeriesName = searchParams.get("selected_series_name") || "";
    let start_date;
    let end_date;
    if (dateRange[0] && dateRange[1]) {
      start_date = formatDateLocal(dateRange[0]);
      end_date = formatDateLocal(dateRange[1]);
    }
    try {
      if (conditions.length > 0 && conditions[0].selectedData !== "") {
        for (const item of conditions) {
          const { selectedData, selectedCondition, selectedValue, type, startDate, endDate } = item;

          if (selectedData && selectedCondition && Array.isArray(selectedValue)) {
            if (!DateTimeType.includes(type) && selectedValue.length === 0) {
              toast.error(`Please select or enter a value for ${selectedData}`);
              return;
            } else if (DateTimeType.includes(type) && selectedCondition === "between" && (!startDate || !endDate)) {
              toast.error(`Please enter both the start and end dates for ${selectedData}`);
              return;
            } else if (DateTimeType.includes(type) && !startDate) {
              toast.error(`Please enter a date for ${selectedData}`);
              return;
            }
          } else {
            toast.error("Please select the data");
            return;
          }
        }
        const createfilter = createFilters(conditions);

        if (createfilter.filter_options.length > 0) {
          if (createfilter && reportTitle && categoryValue) {
            setLoading(true);
            await dispatch(
              getfilterdatadrill({
                report_name: reportTitle,
                email: user.user_email_id,
                customer_id: user.customer_id,
                database_type: user.database_type,
                filter_options: createfilter.filter_options,
                filter_operations: createfilter.filter_operations,
                filter_value: categoryValue,
                selectedSeriesName: selectedSeriesName,
                sorting_options: sorting,
                start_date,
                end_date,
                page_no: newState.pageIndex + 1,
                page_size: newState.pageSize,
                flag: "drilldownpage"

              })
            );
          } else {
            setLoading(true);
            await dispatch(
              getfilterdatadrill({
                report_name: reportTitle,
                email: user.user_email_id,
                customer_id: user.customer_id,
                database_type: user.database_type,
                filter_options: createfilter.filter_options,
                filter_operations: createfilter.filter_operations,
                page_no: newState.pageIndex + 1,
                page_size: newState.pageSize,
                start_date,
                end_date,
                sorting_options: sorting,
                filter_value: "",
                selectedSeriesName: "",
                flag: "drilldownpage"
              })
            );
          }
        }
      } else {
        if (reportTitle && categoryValue) {
          setLoading(true);
          await dispatch(
            getdataforDrilldown({
              customer_id: user?.customer_id,
              master_report: reportTitle,
              filter_value: categoryValue,
              selectedSeriesName: selectedSeriesName,
              page_no: newState.pageIndex + 1,
              start_date,
              end_date,
              page_size: newState.pageSize,
              database_type: user.database_type,
            })
          );
        } else {
          setLoading(true);
          await dispatch(
            getdataforDrilldown({
              customer_id: user?.customer_id,
              master_report: reportTitle,
              selectedSeriesName: selectedSeriesName,
              filter_value: "",
              page_no: newState.pageIndex + 1,
              start_date,
              end_date,
              page_size: newState.pageSize,
              database_type: user.database_type,
            })
          );
        }
      }
    } catch (error) {
      console.error("Error generating report ID:", error);
    } finally {
      setLoading(false);
    }

    // Closing brace was missing before updating pagination
    setPagination((old) => {
      const newPagination = typeof updaterOrState === "function" ? updaterOrState(old) : updaterOrState;
      return newPagination;
    });
  };


  const [error, setError] = useState(null);

  const drilldownData = apiData?.reportmanagement.detaildatafordrilldown;
  const exportedfilepath = apiData?.reportmanagement?.exportedfilepath;

  useEffect(() => {
    const fetchAndDecompressFile = async () => {
      try {
        const compressedData = new Uint8Array(exportedfilepath.data);
        const Filename = exportedfilepath.headers.get('X-Filename');
        const decompressedData = pako.inflate(compressedData);
        const blob = new Blob([decompressedData], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = Filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (err) {
        setError("Failed to fetch or decompress the file.");
        console.error(err);
      }
    };

    fetchAndDecompressFile();
  }, [exportedfilepath]);

  // const columns = useMemo(() => {
  //   setRowCount(drilldownData && drilldownData?.total_records || 10)
  //   return drilldownData?.column_names?.map(column => {
  //     const dateType = drilldownData?.column_types?.[column] && DateTimeType.includes(drilldownData?.column_types[column])
  //       ? 'datetime'
  //       : drilldownData?.column_types?.[column] === 'DATE'
  //         ? 'date'
  //         : null;

  //     if (dateType === 'datetime') {
  //       return {
  //         accessorFn: (originalRow) => {
  //           const value = originalRow[column];
  //           return value ? new Date(value) : null;
  //         },
  //         id: column,
  //         header: column,
  //         filterVariant: 'datetime',
  //         Cell: ({ cell }) => {
  //           const value = cell.getValue();
  //           if (!value) return ""; // Return empty string if value is null or undefined
  //           return `${value.toLocaleDateString()} ${value.toLocaleTimeString()}`;
  //         },

  //       };
  //     } else if (dateType === 'date') {
  //       return {
  //         accessorFn: (originalRow) => {
  //           const value = originalRow[column];
  //           return value ? new Date(value) : null;
  //         },
  //         id: column,
  //         header: column,
  //         filterVariant: 'date',
  //         Cell: ({ cell }) => {
  //           const value = cell.getValue();
  //           if (!value) return "";
  //           return value.toLocaleDateString();
  //         },
  //       };
  //     }
  //     else {
  //       return {
  //         header: column,
  //         id: column,
  //         accessorFn: row => String(row[column]),
  //         enableClickToCopy: false,
  //         filterVariant: 'multi-select',
  //       };
  //     }
  //   }) || [];
  // }, [data, drilldownData]);

  const columns = useMemo(() => {
    setRowCount(drilldownData && drilldownData?.total_records || 10);

    return drilldownData?.column_names?.map(column => {

      const dateType =
        drilldownData?.column_types?.[column] &&
          DateTimeType.includes(drilldownData?.column_types[column])
          ? "datetime"
          : drilldownData?.column_types?.[column] === "DATE"
            ? "date"
            : null;
      // ========================= DATETIME =========================
      if (dateType === "datetime") {
        return {
          id: column,
          header: column,
          accessorKey: column, // <-- KEEP ORIGINAL VALUE, NO CONVERSION
          filterVariant: "datetime",
          Cell: ({ cell }) => {
            let value = cell.getValue();
            if (!value || typeof value !== "string") return "";

            value = value.split("+")[0];
            value = value.split(".")[0];
            value = value.replace("T", " ");

            return value;
          }

        };
      }
      // ======================== DATE =========================
      if (dateType === "date") {
        return {
          id: column,
          header: column,
          accessorKey: column, // <-- KEEP ORIGINAL VALUE
          filterVariant: "date",
          Cell: ({ cell }) => {
            let value = cell.getValue();
            if (!value || typeof value !== "string") return "";

            value = value.split("+")[0];
            value = value.split(".")[0];
            value = value.replace("T", " ");

            return value;
          }

        };
      }
      // ========================= DEFAULT =========================
      return {
        header: column,
        id: column,
        accessorFn: row => String(row[column]),
        enableClickToCopy: false,
        filterVariant: "multi-select"
      };
    }) || [];
  }, [data, drilldownData]);
  
  useMemo(() => {
    if (drilldownData?.data) {
      setData(drilldownData.data);
    }
  }, [drilldownData]);

  function createFilters(inputArray) {
    const filter_operations = [];
    const filter_options = [];
    inputArray.forEach(item => {
      const { selectedData, selectedCondition, selectedValue, type, startDate, endDate } = item;
      if (selectedData) {
        const operationEntry = {
          [selectedData]: selectedCondition,
        };
        filter_operations.push(operationEntry);
        let value = [...selectedValue];
        if (DateTimeType.includes(type)) {
          if (startDate) value.push(startDate);
          if (endDate) value.push(endDate);
        }
        const optionEntry = {
          [selectedData]: value,
        };
        filter_options.push(optionEntry);
      }
    });
    return { filter_operations, filter_options };
  }

  const handleExportPdf = async () => {
    try {
      const visibleColumns = columns.filter((column) => table.getColumn(column.id).getIsVisible());
      const columnThatNeedToExport = visibleColumns.map((item) => item.header);
      if (columnThatNeedToExport.length === 0) {
        toast.error(`None of the column is selected you can select at list one column in filter`);
        return
      } else if (columnThatNeedToExport.length > 12) {
        toast.warn(`For PDF download, a maximum of 12 columns is supported. Kindly Select up to 12 columns.`);
        return
      }
      let start_date;
      let end_date;
      if (dateRange[0] && dateRange[1]) {
        start_date = formatDateLocal(dateRange[0]);
        end_date = formatDateLocal(dateRange[1]);
      }
      if (conditions.length > 0 && conditions[0].selectedData !== "") {
        for (const item of conditions) {
          const { selectedData, selectedCondition, selectedValue, type, startDate, endDate } = item;

          if (selectedData && selectedCondition && Array.isArray(selectedValue)) {
            if (!DateTimeType.includes(type) && selectedValue.length === 0) {
              toast.error(`Please select or enter a value for ${selectedData} in filter `);
              return;
            } else if (DateTimeType.includes(type) && selectedCondition === "between" && (!startDate || !endDate)) {
              toast.error(`Please enter both the start and end dates for ${selectedData} in filter`);
              return;
            } else if (DateTimeType.includes(type) && !startDate) {
              toast.error(`Please enter a date for ${selectedData} in filter`);
              return;
            }
          } else {
            toast.error("Please select the data in filter");
            return;
          }
        }
        const createfilter = createFilters(conditions)
        setLoading(true);
        await dispatch(exportpdfreport({
          report_name: titlereport,
          database_type: user.database_type,
          file_format: "pdf",
          customer_id: user.customer_id,
          user_email_id: user?.user_email_id,
          column_names: columnThatNeedToExport,
          filter_options: createfilter.filter_options,
          filter_operations: createfilter.filter_operations,
          filter_value: categoryValue,
          selectedSeriesName: selectedSeriesName,
          sorting_options: sorting,
          start_date,
          end_date,
          flag: "drilldownpage"
        }))

      } else {
        setLoading(true);
        await dispatch(exportpdfreport({
          report_name: titlereport,
          database_type: user.database_type,
          file_format: "pdf",
          customer_id: user.customer_id,
          user_email_id: user?.user_email_id,
          column_names: columnThatNeedToExport,
          filter_options: [],
          filter_operations: [],
          filter_value: categoryValue,
          selectedSeriesName: selectedSeriesName,
          sorting_options: sorting,
          start_date,
          end_date,
          flag: "drilldownpage"
        }))
      }
    } catch (error) {
      console.error("Error generating report ID:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleExportExcel = async () => {
    const visibleColumns = columns.filter((column) => table.getColumn(column.id).getIsVisible());
    const columnThatNeedToExport = visibleColumns.map((item) => item.header);
    if (columnThatNeedToExport.length === 0) {
      toast.error(`None of the column is selected you can select at list one column in filter`);
      return
    }
    try {
      let start_date;
      let end_date;
      if (dateRange[0] && dateRange[1]) {
        start_date = formatDateLocal(dateRange[0]);
        end_date = formatDateLocal(dateRange[1]);
      }
      if (conditions.length > 0 && conditions[0].selectedData !== "") {
        for (const item of conditions) {
          const { selectedData, selectedCondition, selectedValue, type, startDate, endDate } = item;
          if (selectedData && selectedCondition && Array.isArray(selectedValue)) {
            if (!DateTimeType.includes(type) && selectedValue.length === 0) {
              toast.error(`Please select or enter a value for ${selectedData} in filter`);
              return;
            } else if (DateTimeType.includes(type) && selectedCondition === "between" && (!startDate || !endDate)) {
              toast.error(`Please enter both the start and end dates for ${selectedData} in filter`);
              return;
            } else if (DateTimeType.includes(type) && !startDate) {
              toast.error(`Please enter a date for ${selectedData} in filter`);
              return;
            }
          } else {
            toast.error("Please select the data in filter");
            return;
          }
        }
        const createfilter = createFilters(conditions)
        setLoading(true);
        await dispatch(exportexcelreport({
          report_name: titlereport,
          database_type: user.database_type,
          file_format: "excel",
          customer_id: user.customer_id,
          user_email_id: user?.user_email_id,
          column_names: columnThatNeedToExport,
          filter_options: createfilter.filter_options,
          filter_operations: createfilter.filter_operations,
          filter_value: categoryValue,
          selectedSeriesName: selectedSeriesName,
          sorting_options: sorting,
          start_date,
          end_date,
          flag: "drilldownpage"

        }))
      } else {
        setLoading(true);
        await dispatch(exportexcelreport({
          report_name: titlereport,
          database_type: user.database_type,
          file_format: "excel",
          customer_id: user.customer_id,
          user_email_id: user?.user_email_id,
          column_names: columnThatNeedToExport,
          filter_options: [],
          filter_operations: [],
          filter_value: categoryValue,
          selectedSeriesName: selectedSeriesName,
          sorting_options: sorting,
          start_date,
          end_date,
          flag: "drilldownpage"
        }))
      }
    } catch (error) {
      console.error("Error generating report ID:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleExportCSV = async () => {
    try {
      const visibleColumns = columns.filter((column) => table.getColumn(column.id).getIsVisible());
      const columnThatNeedToExport = visibleColumns.map((item) => item.header);
      if (columnThatNeedToExport.length === 0) {
        toast.error(`None of the column is selected you can select at list one column in filter`);
        return
      }
      let start_date;
      let end_date;
      if (dateRange[0] && dateRange[1]) {
        start_date = formatDateLocal(dateRange[0]);
        end_date = formatDateLocal(dateRange[1]);
      }
      if (conditions.length > 0 && conditions[0].selectedData !== "") {
        for (const item of conditions) {
          const { selectedData, selectedCondition, selectedValue, type, startDate, endDate } = item;

          if (selectedData && selectedCondition && Array.isArray(selectedValue)) {
            if (!DateTimeType.includes(type) && selectedValue.length === 0) {
              toast.error(`Please select or enter a value for ${selectedData} in filter`);
              return;
            } else if (DateTimeType.includes(type) && selectedCondition === "between" && (!startDate || !endDate)) {
              toast.error(`Please enter both the start and end dates for ${selectedData} in filter`);
              return;
            } else if (DateTimeType.includes(type) && !startDate) {
              toast.error(`Please enter a date for ${selectedData} in filter`);
              return;
            }
          } else {
            toast.error("Please select the data in filter");
            return;
          }
        }
        const createfilter = createFilters(conditions)
        setLoading(true);
        await dispatch(exportcsvreport({
          report_name: titlereport,
          database_type: user.database_type,
          file_format: "csv",
          customer_id: user.customer_id,
          user_email_id: user?.user_email_id,
          column_names: columnThatNeedToExport,
          filter_options: createfilter.filter_options,
          filter_operations: createfilter.filter_operations,
          filter_value: categoryValue,
          selectedSeriesName: selectedSeriesName,
          sorting_options: sorting,
          start_date,
          end_date,
          flag: "drilldownpage"
        }))
      } else {
        setLoading(true);
        await dispatch(exportcsvreport({
          report_name: titlereport,
          database_type: user.database_type,
          file_format: "csv",
          customer_id: user.customer_id,
          user_email_id: user?.user_email_id,
          column_names: columnThatNeedToExport,
          filter_options: [],
          filter_operations: [],
          filter_value: categoryValue,
          selectedSeriesName: selectedSeriesName,
          sorting_options: sorting,
          start_date,
          end_date,
          flag: "drilldownpage"
        }))
      }
    } catch (error) {
      console.error("Error generating report ID:", error);
    } finally {
      setLoading(false);
    }
  };

  const handelcolumnchanges = async () => {
    setOpenCustomFilter((prev) => !prev);
    setShowcolumnFilter((prev) => !prev);
  };

  const table = useMaterialReactTable({
    columns,
    data,
    enableStickyHeader: true,
    enableStickyFooter: true,
    paginationDisplayMode: "pages",
    enableColumnResizing: true,
    enableGlobalFilter: false,
    enableColumnActions: false,
    enableClickToCopy: false,
    manualPagination: true,
    layoutMode: 'grid',
    rowCount: rowCount,
    onShowColumnFiltersChange: handelcolumnchanges,
    state: { sorting, pagination, showColumnFilters: showcolumnFilter, },
    onSortingChange: (newSorting) => {
      const newSortingsorting = newSorting();
      const updatedSorting = [...sorting];
      newSortingsorting.forEach((newSort) => {
        const existingIndex = updatedSorting.findIndex((s) => s.id === newSort.id);
        if (existingIndex > -1) {
          if (updatedSorting[existingIndex].desc !== newSort.desc) {
            updatedSorting.splice(existingIndex, 1);

          } else {
            updatedSorting[existingIndex] = newSort;
          }
        } else {
          updatedSorting.push(newSort);
        }
      });

      setSorting(updatedSorting);
    },
    isMultiSortEvent: () => true,

    muiTableBodyCellProps: {
      sx: {
        cursor: 'pointer',
        '&:tr td hover': {
          backgroundColor: '#e0f7fa', // Row hover color
        },
      },
    },

    enableColumnPinning: true,
    muiTableContainerProps: {
      sx: (theme) => ({
        "td[data-pinned='true']::before,th[data-pinned='true']::before": {
          background: theme.palette.primary.main,
        },
        "td[data-pinned='true'],th[data-pinned='true']": {
          color: theme.palette.common.white,
        },
        padding: 0,
        margin: 0,
        width: '100%',
        overflowX: 'auto',

      }),
    },
    enableColumnOrdering: true,

    muiPaginationProps: {
      variant: "outlined",
      shape: "rounded",
      sx: (theme) => ({
        "& .Mui-selected": {
          background: `${theme.palette.primary.main} !important`,
          color: theme.palette.common.white,
        },

      }),
    },
    renderTopToolbarCustomActions: ({ table }) => (
      <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Tooltip title="Download">
            <IconButton onClick={handleClick} >
              <span style={{ height: "22px", color: "white" }}>
                <GetAppIcon style={{ color: "white" }} />
              </span>
            </IconButton>
          </Tooltip>
          {enableRangeFilter && enableRangeFilter === "yes" && (
            <Tooltip title="Range Filter">
              <IconButton onClick={handleRangeClick}>
                <FilterAltIcon style={{ color: "white" }} />
              </IconButton>
            </Tooltip>
          )}

          <Menu
            id="export-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
          >
            <MenuItem onClick={() => handleExportPdf()}>
              <MdPictureAsPdf color="primary" /> Export PDF
            </MenuItem>
            <MenuItem onClick={() => handleExportExcel()}>
              <FaFileExcel color="primary" /> Export Excel
            </MenuItem>
            <MenuItem onClick={() => handleExportCSV()}>
              <FaFileCsv color="primary" /> Export CSV
            </MenuItem>
          </Menu>
          <Tooltip title="Clear All Sorting">
            <span>
              <Button
                size="small"
                color="primary"

                onClick={() => setSorting([])}

                disabled={sorting.length === 0}
              >
                <ClearAllIcon style={{ color: "white" }} />
              </Button>
            </span>
          </Tooltip>
        </Box>
        {/* Centered and Bold Caption */}
        <Typography
          variant="h6" // Adjust variant as per your need
          sx={{ textAlign: 'center', fontWeight: 'bold', flex: 1 }} // Center and make bold
        >
          {table?.getState()?.caption || drilldownData?.report_title}
        </Typography>
      </Box>
    ),
    enableColumnFilters: true,
    enableFacetedValues: true,
    manualPagination: true,
    onPaginationChange: handlePaginationChange,
    initialState: { pagination: { pageSize: 10, pageIndex: 0 }, showColumnFilters: showcolumnFilter, density: 'compact' },

  });

  return (
    <Box sx={{ px: 5, border: '1px solid #ddd', borderRadius: '4px' }}>
      {openCustomFilter && <CustomFilterDrilldown setOpenCustomFilter={setOpenCustomFilter} columns={drilldownData?.column_types || []} data={drilldownData?.data || []} pagination={pagination} setShowcolumnFilter={setShowcolumnFilter} conditions={conditions} setConditions={setConditions} sorting={sorting} length={conditions.length} dateRange={dateRange} />}
      {titlereport && (
        <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#000;', pb: 1, mb: 2, mt: 2, textAlign: 'center' }}>
          {titlereport}
        </Typography>
      )}

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
          <CircularProgress />
        </Box>
      ) : (
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <Box sx={{ px: 5, py: 3, border: '1px solid #ddd', borderRadius: '4px' }}>
            <MaterialReactTable table={table} sx={{ width: '100%', overflowX: 'auto', border: '2px solid #ddd', borderRadius: '10px' }} />
          </Box>
        </LocalizationProvider>
      )}
      <Popover
        open={rangeOpen}
        anchorEl={rangeAnchorEl}
        onClose={handleCancel}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        PaperProps={{
          sx: {
            p: 2,
            display: "flex",
            flexDirection: "column",
            gap: 2,
            minWidth: 520,
            minHeight: 340,
            borderRadius: "16px", // smooth rounded corners
            boxShadow: "0 6px 18px rgba(0,0,0,0.15)", // soft shadow
            background: "#fff",
          },
        }}
      >
        {/* Left: Date Pickers */}
        {/* <Box sx={{ display: "flex", flexDirection: "column", flex: 1, minWidth: 320 }}> */}
        <Box sx={{ display: "flex", gap: 2, mb: 1, alignItems: "center" }}>
          <TextField
            label="From"
            size="small"
            type="date"
            value={dateRange[0] ? dateRange[0].toISOString().substring(0, 10) : ""}
            onChange={(e) => {
              const date = new Date(e.target.value);
              setDateRange([date, dateRange[1]]);
            }}
            InputLabelProps={{ shrink: true }}
            sx={{
              flex: 1,
              borderRadius: "10px",
              "& fieldset": {
                borderRadius: "10px",
              },
            }}
            inputProps={{
              value: dateRange[0]
                ? dateRange[0].toISOString().substring(0, 10)
                : "",
              readOnly: true,
            }}
          />
          <TextField
            label="To"
            size="small"
            type="date"
            value={dateRange[1] ? dateRange[1].toISOString().substring(0, 10) : ""}
            onChange={(e) => {
              const date = new Date(e.target.value);
              setDateRange([dateRange[0], date]);
            }}
            InputLabelProps={{ shrink: true }}
            sx={{
              flex: 1,
              borderRadius: "10px",
              "& fieldset": {
                borderRadius: "10px",
              },
            }}
            inputProps={{
              value: dateRange[1]
                ? dateRange[1].toISOString().substring(0, 10)
                : "",
              readOnly: true,
            }}
          />

        </Box>
        <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
          <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
            <ReactDatePicker
              selected={dateRange[0]}
              onChange={(date) => setDateRange([date, dateRange[1]])}
              selectsStart
              startDate={dateRange[0]}
              endDate={dateRange[1]}
              inline
            />
            <ReactDatePicker
              selected={dateRange[1]}
              onChange={(date) => setDateRange([dateRange[0], date])}
              selectsEnd
              startDate={dateRange[0]}
              endDate={dateRange[1]}
              minDate={dateRange[0]}
              inline
            />
          </Box>
          <Box
            sx={{ minWidth: 140, display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "center" }}
          >
            <Typography variant="body2"
              sx={{
                minWidth: 130,
                fontWeight: 600,
                fontSize: "0.9rem",
                color: "#fff",
                backgroundColor: "#1976d2",
                borderRadius: "12px",
                px: 2,
                py: 0.5,
                display: "inline-block",
                marginBottom: "10px",
                boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
              }}>
              Select Range
            </Typography>
            <List
              sx={{
                border: "1px solid #1976d2",
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                p: 0.5,
              }}
            >
              {dropdownOptions.map((opt) => (
                <ListItem key={opt.value} disablePadding>
                  <ListItemButton
                    selected={
                      (opt.value !== "custom" &&
                        dateRange[0] &&
                        dateRange[1] &&
                        (dateRange[1] - dateRange[0]) / (1000 * 60 * 60 * 24) + 1 === opt.value) ||
                      (opt.value === "custom" && (!dateRange[0] || !dateRange[1]))
                    }
                    onClick={() => handleQuickSelect(opt.value)}
                    sx={{
                      borderRadius: "8px",
                      mb: 0.5,
                      "&.Mui-selected": {
                        bgcolor: "#e3f2fd",
                        color: "#1976d2",
                        fontWeight: "bold",
                      },
                      "&:hover": {
                        bgcolor: "#f0f7ff",
                      },
                    }}
                  >
                    {opt.label}
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </Box>

        </Box>
        <Box
          sx={{
            position: "absolute",
            bottom: 20,
            right: 8,
            display: "flex",
            gap: 1,
          }}
        >
          <Button
            variant="contained"
            size="small"
            onClick={handleApply}
            disabled={!dateRange[0] || !dateRange[1]}
            sx={{
              borderRadius: "20px",
              textTransform: "none",
              px: 2,
              background: "#1976d2",
              "&:hover": { background: "#125aa0" },
            }}
          >
            Apply
          </Button>
          <Button
            variant="outlined"
            size="small"
            onClick={handleCancel}
            sx={{
              borderRadius: "20px",
              textTransform: "none",
              px: 2,
              color: "#1976d2",
              borderColor: "#1976d2",
              "&:hover": { borderColor: "#125aa0", color: "#125aa0" },
            }}
          >
            Cancel
          </Button>
        </Box>
      </Popover>
    </Box>
  );
}


export default DrillDown;